import React from 'react';

// Light-theme KPI/summary row shown above the overall cost charts. It mirrors
// the look of InfraHealthSummary so the cost and infra sections read as one
// design language.
//
// This is a pure presentational component: the caller decides which cards to
// pass in. Any KPI whose source value is missing is omitted upstream rather
// than rendered as a zero, so an empty `cards` array renders nothing.
//
// Each card: { label, value, delta?, deltaDirection?, hint?, valueTone? }
//  - value          already-formatted display string
//  - delta          already-formatted change string (e.g. "+12.3%")
//  - deltaDirection  'up' | 'down' | 'neutral' — drives the delta colour only;
//                    the caller owns whether up/down is good or bad
//  - hint           optional sub-label under the value
//  - valueTone      'positive' tints the value green (e.g. potential savings);
//                    omitted = the default value colour
const CostKpiRow = ({ cards }) => {
  const list = Array.isArray(cards) ? cards.filter(Boolean) : [];
  if (list.length === 0) return null;

  return (
    <div className="cost-kpi-row" role="group" aria-label="Cost summary">
      {list.map((card) => {
        const direction = card.deltaDirection || 'neutral';
        const ariaLabel = card.delta
          ? `${card.label}: ${card.value}, change ${card.delta}`
          : `${card.label}: ${card.value}`;
        return (
          <div key={card.label} className="cost-kpi-card" aria-label={ariaLabel}>
            <span className="cost-kpi-label">{card.label}</span>
            <span className={`cost-kpi-value${card.valueTone === 'positive' ? ' positive' : ''}`}>{card.value}</span>
            <div className="cost-kpi-sub">
              {card.delta && (
                <span className={`cost-kpi-delta ${direction}`} aria-hidden="true">
                  {card.delta}
                </span>
              )}
              {card.hint && <span className="cost-kpi-hint">{card.hint}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CostKpiRow;
